module.exports = __webpack_public_path__ + "img/retired-2013-visit.642bb17a.jpg";